<i [tooltip]="file.name"
   (click)="onClick()"
   class="far fa-fw cursor-pointer"
   [ngClass]="file.name | fileTypeIcon">
</i>
